'use strict'

const login = require('../login/login')
const { accessibleModal } = require('../utilities/accessibility')
const throttle = require('lodash/throttle');
const debounce = require('lodash/debounce');

const SELECTORS = {
    element: '.js-header-wrap',
    itemNavigation: '.js-header-item',
    itemButton: '.js-header-btn',
    submenu: '.js-header-megamenu',
    submenuTop: '.js-header-megamenu.cc-header__megamenu--main',
    submenuOverlay: '.js-header-megamenu-overlay',
    submenuOpened: '.js-header-megamenu.cc-header__megamenu--open',
    backButton: '.js-header-backbutton',
    mobileMenu: '.js-mobile-menu',
    openMobileMenu: '.js-header-openmenu',
    loginButton: '.js-step-login',
    minicartModal: '#minicartModal',
    linksToToggleActive: '.js-link',
    header: '.js-header'
}

const CLASSES = {
    open: 'cc-header__megamenu--open',
    mobileOpen: 'cc-mobilemenu--open',
    bodyClassLogin: 'js-page-registration',
    active: 'cc-active'
}

/**
 * Header class that handles the header navigation
 */
class Header {
    constructor(element) {
        this.element = element;
        this.itemNav = element.find(SELECTORS.itemNavigation);
        this.itemBtn = element.find(SELECTORS.itemButton);
        this.submenu = element.find(SELECTORS.submenu);
        this.submenuTop = element.find(SELECTORS.submenuTop);
        this.submenuOverlay = element.find(SELECTORS.submenuOverlay);
        this.submenuOpened = element.find(SELECTORS.submenuOpened);
        this.itemBackButton = element.find(SELECTORS.backButton);
        this.itemOpenMenu = $(SELECTORS.openMobileMenu);
        this.mobileMenu = $(SELECTORS.mobileMenu);
        this.loginButton = $(SELECTORS.loginButton);
        this.minicartModal = $(SELECTORS.minicartModal);
        this.bodyClassLogin = $(SELECTORS.bodyClassLogin);
        this.links = $(SELECTORS.linksToToggleActive);
        this.header = $(SELECTORS.header);
        this.currentLevel = 0;
        this.submenuStack = [];
        this.initEvents();
        this.checkActiveStateFromURL();
    }

    initEvents() {
        this.toggleAccessibilityFeatures();

        this.itemOpenMenu.on('click', () => {
            $(SELECTORS.submenu).removeAttr('inert');
            this.toggleMenuMobile();
        })

        this.loginButton.on('click', () => {
            this.closeModalOnLoginPage();
        })

        this.submenuOverlay.on('mouseenter', (e) => {
            if (!window.isDesktop) return;
            if ($(e.currentTarget).is(this.submenuOverlay)) {
                $(this.submenu).css('pointer-events', 'none');
            }
        });

        this.submenuOverlay.on('mouseleave', (e) => {
            $(this.submenu).removeAttr('style');
        });

        this.itemBtn.on('mouseover', (e) => {
            if (!window.isDesktop) return;
            const subMenu = $(e.currentTarget).next(SELECTORS.submenu);
            if (!subMenu.length || !subMenu.hasClass('cc-header__megamenu--main')) return;
            $(SELECTORS.submenuOpened).removeClass(CLASSES.open);
            this.submenuTop.attr('inert', 'inert');
            this.submenuTop.attr('aria-hidden', 'true');
            this.submenuTop.prev(SELECTORS.itemButton).attr('aria-expanded', 'false');
            subMenu.removeAttr('inert');
            subMenu.addClass(CLASSES.open);
            subMenu.attr('aria-hidden', 'false');
            $(e.currentTarget).attr('aria-expanded', 'true');
        });

        this.itemBtn.on('mouseleave', (e) => {
            if (!window.isDesktop) return;
            const subMenu = $(e.currentTarget).next(SELECTORS.submenuTop);
            if (!subMenu.length) return;
            if (subMenu[0].contains(e.relatedTarget)) return;
            subMenu.removeClass(CLASSES.open);
            subMenu.attr('inert', 'inert');
            subMenu.attr('aria-hidden', 'true');
            $(e.currentTarget).attr('aria-expanded', 'false');
        });

        this.itemBtn.on('click keydown', (e) => {
            if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && window.isDesktop) {
                const $current = $(e.currentTarget);
                const isInsidePanel = $current.closest(SELECTORS.submenuTop).length > 0;

                if (isInsidePanel && e.key === 'ArrowRight') {
                    const subMenuArrow = $current.next(SELECTORS.submenu);
                    if (subMenuArrow.length) {
                        e.preventDefault();
                        e.stopPropagation();
                        const $siblingPanels = subMenuArrow.closest(SELECTORS.submenuTop).find(SELECTORS.submenuOpened).not(subMenuArrow);
                        $siblingPanels.prev(SELECTORS.itemButton).attr('aria-expanded', 'false');
                        $siblingPanels.attr('aria-hidden', 'true');
                        $siblingPanels.attr('tabindex', '-1');
                        $siblingPanels.removeClass(CLASSES.open);
                        subMenuArrow.addClass(CLASSES.open);
                        subMenuArrow.attr('aria-hidden', 'false');
                        subMenuArrow.removeAttr('tabindex');
                        $current.attr('aria-expanded', 'true');
                    }
                    return;
                }

                if (isInsidePanel && e.key === 'ArrowLeft') {
                    return;
                }

                const $allL1 = this.element.find(SELECTORS.itemButton).filter(function () {
                    return $(this).closest(SELECTORS.submenu).length === 0;
                });
                const currentIndex = $allL1.index($current);
                if (currentIndex === -1) return;
                e.preventDefault();
                e.stopPropagation();
                const nextIndex = e.key === 'ArrowRight'
                    ? (currentIndex + 1) % $allL1.length
                    : (currentIndex - 1 + $allL1.length) % $allL1.length;
                $(SELECTORS.submenuOpened).removeClass(CLASSES.open);
                this.submenuTop.attr('inert', 'inert');
                this.submenuTop.attr('aria-hidden', 'true');
                this.submenuTop.prev(SELECTORS.itemButton).attr('aria-expanded', 'false');
                $allL1.eq(nextIndex).trigger('focus');
                return;
            }

            const subMenu = $(e.currentTarget).next(SELECTORS.submenu);
            if (!subMenu.length) return;

            if (e.key === 'Escape' && window.isDesktop) {
                e.preventDefault();
                e.stopPropagation();
                const $topMenu = $(e.currentTarget).closest(SELECTORS.submenuTop);
                const $trigger = $topMenu.prev(SELECTORS.itemButton);
                $(SELECTORS.submenuOpened).removeClass(CLASSES.open);
                $(SELECTORS.submenuOpened).attr('aria-hidden', 'true');
                $(SELECTORS.submenuOpened).attr('tabindex', '-1');
                $topMenu.attr('inert', 'inert');
                $trigger.attr('aria-expanded', 'false');
                if ($trigger.length) {
                    $trigger.trigger('focus');
                }
            }

            if ((e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') && window.isDesktop) {
                e.preventDefault();
                if (subMenu.hasClass('cc-header__megamenu--main')) {
                    $(SELECTORS.submenuOpened).prev(SELECTORS.itemButton).attr('aria-expanded', 'false');
                    $(SELECTORS.submenuOpened).attr('inert', 'inert');
                    $(SELECTORS.submenuOpened).attr('aria-hidden', 'true');
                    $(SELECTORS.submenuOpened).attr('tabindex', '-1');
                    $(SELECTORS.submenuOpened).removeClass(CLASSES.open);
                } else {
                    const $siblingPanels = subMenu.closest(SELECTORS.submenuTop).find(SELECTORS.submenuOpened).not(subMenu);
                    $siblingPanels.prev(SELECTORS.itemButton).attr('aria-expanded', 'false');
                    $siblingPanels.attr('aria-hidden', 'true');
                    $siblingPanels.attr('tabindex', '-1');
                    $siblingPanels.removeClass(CLASSES.open);
                }
                subMenu.removeAttr('inert');
                subMenu.addClass(CLASSES.open);
                subMenu.attr('aria-hidden', 'false');
                subMenu.removeAttr('tabindex');
                $(e.currentTarget).attr('aria-expanded', 'true');
            } else if ((e.type === 'click' || e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') && !window.isDesktop) {
                e.preventDefault();
                subMenu.addClass(CLASSES.open);
                this.submenuStack.push(subMenu);
            }
        });

        this.itemNav.on('keydown', (e) => {
            if (e.key === 'Escape' && window.isDesktop) {
                e.preventDefault();
                e.stopPropagation();
                const submenu = $(e.currentTarget).hasClass(CLASSES.open) ? $(e.currentTarget) : $(e.currentTarget).closest('.cc-header__megamenu--open');
                const $topMenu = $(submenu).closest(SELECTORS.submenuTop).length ? $(submenu).closest(SELECTORS.submenuTop) : $(submenu);
                const $trigger = $topMenu.prev(SELECTORS.itemButton);
                $(submenu).attr('inert', 'inert');
                $(submenu).removeClass(CLASSES.open);
                $(submenu).attr('aria-hidden', 'true');
                $(submenu).attr('tabindex', '-1');
                $trigger.attr('aria-expanded', 'false');
                $trigger.trigger('focus');
            }
        });

        this.submenu.on('keydown mouseleave', (e) => {
            if ((e.key === 'Escape' || e.type === 'mouseleave') && window.isDesktop) {
                e.stopPropagation();
                const $current = $(e.currentTarget);
                const isTopLevel = $current.hasClass('cc-header__megamenu--main');
                const submenu = $current.hasClass(CLASSES.open) ? $current : $current.closest('.cc-header__megamenu--open');
                $(submenu).removeClass(CLASSES.open);
                $(submenu).attr('aria-hidden', 'true');
                $(submenu).attr('tabindex', '-1');
                if (isTopLevel) {
                    $current.attr('inert', 'inert');
                }
                const $closeTrigger = (isTopLevel ? $current : $(submenu).closest(SELECTORS.submenuTop)).prev(SELECTORS.itemButton);
                $closeTrigger.attr('aria-expanded', 'false');
                if (e.key === 'Escape') {
                    $closeTrigger.trigger('focus');
                }
            }
        });

        this.itemBackButton.on('click', (e) => {
            e.preventDefault();
            const previousSubMenu = this.submenuStack.pop();
            if (previousSubMenu) {
                previousSubMenu.removeClass(CLASSES.open);
            }
        });

        this.mobileMenu.on('keydown', (e) => {
            if (e.key === 'Escape' && !window.isDesktop) {
                this.toggleMenuMobile();
            }
        });

        $(window).on('resize', debounce(() => {
            this.toggleAccessibilityFeatures();
        }, 100));

        $(window).on('scroll', throttle(() => {
            const currentScroll = $(window).scrollTop();

            if (currentScroll > 150) {
                this.header.addClass('cc-header--small');
                $('body').addClass('cc-header-is-small');
            } else if (currentScroll < 100) {
                this.header.removeClass('cc-header--small');
                $('body').removeClass('cc-header-is-small');
            }

            // Hide / show header on scroll direction (mobile)
            /* if (currentScroll >= lastScroll) {
                this.header.removeClass('cc-header--scroll-top').addClass('cc-header--scroll-bottom');
            } else {
                this.header.removeClass('cc-header--scroll-bottom').addClass('cc-header--scroll-top');
            }
            lastScroll = currentScroll; */
        }, 100));
    }

    /**
     * Toggle accessibility features. If the user is on mobile, we will add the modal accessibility features to the menu and its subpanels 
     */
    toggleAccessibilityFeatures() {
        accessibleModal(this.loginButton);

        if (window.isDesktop) {
            this.submenuTop.attr('inert', 'inert');
            this.submenuTop.attr('aria-hidden', 'true');
            return;
        }

        this.submenu.removeAttr('inert');
        this.mobileMenu.attr('role', 'dialog');
        this.mobileMenu.attr('aria-modal', 'true');
        this.mobileMenu.attr('aria-hidden', 'true');
        this.mobileMenu.attr('tabindex', '-1');
        this.mobileMenu.attr('aria-labelledby', 'mobile-menu-trigger');

        accessibleModal(this.itemOpenMenu);

        if (this.itemBtn.length > 0) {
            this.itemBtn.each((index, element) => {
                accessibleModal($(element));
            });
        }
    }

    /**
     * Toggle mobile menu 
     */
    toggleMenuMobile() {
        $('body').toggleClass('cc-body-no-scroll');
        this.mobileMenu.toggleClass(CLASSES.mobileOpen);
        this.itemOpenMenu.toggleClass(CLASSES.mobileOpen);
        if (!this.mobileMenu.hasClass(CLASSES.mobileOpen)) {
            this.submenuStack = [];
            $(SELECTORS.submenu).removeClass(CLASSES.open);
            this.mobileMenu.attr('tabindex', '-1');
            this.mobileMenu.attr('aria-hidden', 'true');
        } else {
            this.mobileMenu.removeAttr('tabindex');
            this.mobileMenu.attr('aria-hidden', 'false');
        }
        this.itemOpenMenu.attr('aria-expanded', this.mobileMenu.hasClass(CLASSES.mobileOpen));

        const FOCUSABLE = 'a[href],button:not([disabled]),button:not(.cc-visibility-hidden),[role="button"],[tabindex]:not([tabindex="-1"])';
        const isOpen = this.mobileMenu.hasClass(CLASSES.mobileOpen);

        if (isOpen) {
            setTimeout(() => {
                const $first = this.mobileMenu.find(FOCUSABLE).filter(':visible').first();
                const target = $first[0] || this.mobileMenu[0];
                if (target) target.focus();
            }, 50);
        } else {
            // restituisci il focus al bottone hamburger quando chiudi
            this.itemOpenMenu.trigger('focus');
        }
    }

     /**
     * Close login modal on login page 
     */
    closeModalOnLoginPage() {
        if (window.isMobile) {
            if($('body').hasClass((CLASSES.bodyClassLogin))){
                this.mobileMenu.removeClass(CLASSES.mobileOpen);
                this.itemOpenMenu.removeClass(CLASSES.mobileOpen);
                this.itemOpenMenu.attr('aria-expanded', this.mobileMenu.hasClass(CLASSES.mobileOpen));
                $('body').removeClass('cc-body-no-scroll');
            }
        } 
    }
    
    /**
     * Check the current URL and add the `active` class to the corresponding menu item.
     */
    checkActiveStateFromURL() {
        const currentURL = window.location.href;
        this.links.each((index, link) => {
            const href = $(link).attr('href');
            if (href && currentURL.includes(href)) {
                $(link).addClass(CLASSES.active).attr('aria-current', 'page');
            }
        });
    }
}

module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        new Header($(element));
    });
}

